import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { History } from '../../models/history.model';
import * as moment from 'moment';
import { forEach } from '@angular/router/src/utils/collection';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  histories: History[] = [];
  liftProperties = ['LiftEngineId', 'LiftTypeId', 'FloorCount', 'MadeAt', 'Description, LoadCapacity'];
  userProperties = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    let data = this.route.snapshot.data.histories;
    this.histories = data.body;
    console.log(this.histories);
  }

  closeHistory($event) {
    this.router.navigate([{ outlets: { history: null } }]);
  }

  formatDatetime(data: string) {
    if (!data) {
      return '-';
    }
    const lastLogin = moment(data);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  showEdited(values: string) {
    let parsedValues = JSON.parse(values);
    let properties = [];
    let returnString = "";

    Object.keys(parsedValues).forEach(key => properties.push(key));
    const intersectedData = this.intersect(this.liftProperties, properties);

    intersectedData.forEach((item) => {
      let itemTranslated = this.translateService.instant('history.'+item);
      returnString += itemTranslated + ' ';
    });

    return returnString;
  }

  intersect(a, b) {
    var d = {};
    var results = [];
    for (var i = 0; i < b.length; i++) {
      d[b[i]] = true;
    }
    for (var j = 0; j < a.length; j++) {
      if (d[a[j]])
        results.push(a[j]);
    }
    return results;
  }
}
